<template>
    <div class="default-checkbox" :class="{ error: errors.length, disabled: disabled }">
        <input class="default-checkbox__input" type="checkbox" :name="name" :id="id" v-model="checkboxValue" :value="value">
        <label class="default-checkbox__label" :for="id">
            <div class="default-checkbox__img" v-if="icon || showIcon">
                <img v-if="icon" :src="icon" :alt="name" loading="lazy">
            </div>
            <span class="default-checkbox__name">{{ label }}</span>
            <span class="default-checkbox__text" v-if="text">{{ text }}</span>
        </label>
        <div class="tooltip" v-if="hintText">
            <span class="tooltip__btn" :class="{'opened':toolTipOpened}" @click="toolTipClick">?</span>
            <div class="tooltip__content">
                <p>{{ hintText }}</p>
            </div>
        </div>
        <div class="default-checkbox__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputCheckbox",
    emits: ['update:modelValue'],
    data() {
        return {
            toolTipOpened: false
        };
    },
    props: {
        modelValue: {
            type: [Boolean, Array, String, Number],
            default: null,
        },
        value: {
            type: [String, Number, Boolean],
            default: ''
        },
        id: {
            type: String,
            required: true,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        hintText: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        checkboxValue: {
            get() {
                if (typeof this.modelValue === 'boolean') {
                    return this.modelValue
                } else if (Array.isArray(this.modelValue)) {
                    return this.modelValue.includes(this.value)
                } else {
                    return this.modelValue === this.value
                }
            },
            set() {
                this.$emit('update:modelValue', this.value)
            }
        }
    },
    methods: {
        toolTipClick() {
            this.toolTipOpened = this.toolTipOpened === false;
        },
    }
}
</script>

<style scoped>

</style>